import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    //重定向
    {
      path: '/',
      redirect: 'home'
    },
    //首页
    {
      path: '/home',
      name: 'home',
      component: resolve => require(['@/pages/PC/home/home.vue'], resolve)
    },
    //产品介绍
    {
      path: '/product',
      name: 'product',
      component: resolve => require(['@/pages/PC/product/product.vue'], resolve)
    },
    //产品详情
    {
      path: '/productDetail',
      name: 'productDetail',
      component: resolve => require(['@/pages/PC/product/productDetail.vue'], resolve)
    },
    //新闻中心
    {
      path: '/newsCenter',
      name: 'newsCenter',
      component: resolve => require(['@/pages/PC/newsCenter/newsCenter.vue'], resolve)
    },
    //新闻详情
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: resolve => require(['@/pages/PC/newsCenter/newsDetail.vue'], resolve)
    },
    //超级工资条
    {
      path: '/payslip',
      name: 'payslip',
      component: resolve => require(['@/pages/PC/payslip/payslip.vue'], resolve)
    },
    //关于我们
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: resolve => require(['@/pages/PC/aboutUs/aboutUs.vue'], resolve)
    },


    //手机端
    {
      path: '/mobileHome',
      name: 'mobileHome',
      component: resolve => require(['@/pages/H5/mobileHome/mobileHome.vue'], resolve)
    },
    //产品介绍
    {
      path: '/mobileProduct',
      name: 'mobileProduct',
      component: resolve => require(['@/pages/H5/mobileProduct/mobileProduct.vue'], resolve)
    },
    //产品详情
    {
      path: '/mobileProductDetail',
      name: 'mobileProductDetail',
      component: resolve => require(['@/pages/H5/mobileProduct/mobileProductDetail.vue'], resolve)
    },
    //打工宝动态
    {
      path: '/mobileNewsCenter',
      name: 'mobileNewsCenter',
      component: resolve => require(['@/pages/H5/mobileNewsCenter/mobileNewsCenter.vue'], resolve)
    },
    //关于我们
    {
      path: '/mobileAboutUs',
      name: 'mobileAboutUs',
      component: resolve => require(['@/pages/H5/mobileAboutUs/mobileAboutUs.vue'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js